import { gql } from '@apollo/client';

export const ADD_SERVICE_PROVIDER_TO_PROGRAMME = gql`
  mutation addServiceProvidersToProgramme($input: AddServiceProvidersToProgrammeInput!) {
    programme: addServiceProvidersToProgramme(input: $input) {
      id
    }
  }
`;
